var _templateObject;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

import React, { useState } from 'react';
import clsx from 'clsx';
import i18n from '@pureartisan/simple-i18n';
import { Button } from 'reactstrap';
import styled from 'styled-components';
import IndicatorTooltip from './IndicatorTooltip';
import { FiArrowRight } from 'react-icons/fi';
import ActiveIndicator from '../App/ActiveIndicator'; // styled reactstrap button

var StyledButton = styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  font-size: 1.4rem;\n  padding: 1rem 2rem 1rem 4rem;\n  svg {\n    margin-left: 0.8rem;\n    margin-right: -0.8rem;\n  }\n"])));

var IndicatorButton = function IndicatorButton(_ref) {
  var indicator = _ref.indicator,
      showHint = _ref.showHint,
      className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["indicator", "showHint", "className"]);

  return /*#__PURE__*/React.createElement(StyledButton, _extends({
    className: clsx('gotham14', className),
    color: "transparent"
  }, props), props.active && /*#__PURE__*/React.createElement(ActiveIndicator, null), i18n.translate(indicator.id), showHint && /*#__PURE__*/React.createElement(IndicatorTooltip, {
    indicator: indicator
  }));
};

export default IndicatorButton;